export default "__VITE_ASSET__TgEvzcKW__"